// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"961348aa","220":"cd892b26","304":"f0ec0928","335":"fc7453b6","453":"03346f77","476":"6d6b20ec","784":"c4f2774b","853":"44a15b53","889":"9f9eb914"}[chunkId] + ".chunk.js";
};